import React, { useEffect, useState } from 'react';
import ApiService from './ApiService/ApiService';
import './RateList.css';
import { FaUser } from 'react-icons/fa';
import { GiGoldBar } from 'react-icons/gi';
import { GiSilverBullet } from 'react-icons/gi';

const RateList = () => {
    const currentDate = new Date().toISOString().split('T')[0];

    const [rates, setRates] = useState({});
    const [editingId, setEditingId] = useState(null);
    const [editableRate, setEditableRate] = useState(null);
    const [newRate, setNewRate] = useState({
        goldRate: '',
        silverRate: '',
        createdAt: currentDate,
        createdBy: '',
    });

    useEffect(() => {
        const fetchRates = async () => {
            try {
                const fetchedRates = await ApiService.getRates();
                const ratesObject = fetchedRates.reduce((acc, rate) => {
                    acc[rate.id] = rate;
                    return acc;
                }, {});
                setRates(ratesObject);
            } catch (error) {
                console.error('Failed to fetch rates:', error);
            }
        };
        fetchRates();
    }, []);

    const handleChange = (e, field) => {
        const value = e.target.value;
        setEditableRate({ ...editableRate, [field]: value });
    };

    const startEditing = (id) => {
        setEditingId(id);
        setEditableRate({ ...rates[id] });
    };

    const saveEdit = async () => {
        if (editableRate) {
            try {
                const rateData = {
                    goldRate: editableRate.goldRate,
                    silverRate: editableRate.silverRate,
                    createdAt: new Date(editableRate.createdAt).toISOString(),
                    createdBy: editableRate.createdBy,
                };
                const updatedRate = await ApiService.updateRate(editingId, rateData);
                setRates({ ...rates, [editingId]: updatedRate });
                setEditingId(null);
                setEditableRate(null);
            } catch (error) {
                console.error('Failed to update rate:', error);
                alert('Failed to update rate. Please try again.');
            }
        }
    };

    const cancelEdit = () => {
        setEditingId(null);
        setEditableRate(null);
    };

    const handleNewRateChange = (e, field) => {
        const value = e.target.value;
        setNewRate({ ...newRate, [field]: value });
    };

    const addNewRate = async () => {
        if (!newRate.goldRate || !newRate.silverRate || !newRate.createdBy) {
            alert('All fields are required!');
            return;
        }

        try {
            const rateData = {
                goldRate: newRate.goldRate,
                silverRate: newRate.silverRate,
                createdAt: new Date(newRate.createdAt).toISOString(),
                createdBy: newRate.createdBy,
            };

            const createdRate = await ApiService.addRate(rateData);
            setRates({
                ...rates,
                [createdRate.id]: createdRate,
            });
            setNewRate({
                goldRate: '',
                silverRate: '',
                createdAt: currentDate,
                createdBy: '',
            });
        } catch (error) {
            console.error('Failed to add rate:', error);
            alert('Failed to add rate. Please try again.');
        }
    };

    return (
        <div className="rate-container">
            <h4 className="rate-header">
                Rates for Gold and Silver
            </h4>

            {/* Add New Rate Section */}
            <div className="add-rate-container">
                <div className="input-fields-group">
                    <div className="input-group">
                        <label>Gold Rate :</label>
                        <div className="input-with-icon">
                            <input
                                type="number"
                                value={newRate.goldRate}
                                onChange={(e) => handleNewRateChange(e, 'goldRate')}
                                className="rate-input"
                            />
                            <GiGoldBar className="input-icon gold-icon" />
                        </div>
                    </div>

                    <div className="input-group">
                        <label>Silver Rate :</label>
                        <div className="input-with-icon">
                            <input
                                type="number"
                                value={newRate.silverRate}
                                onChange={(e) => handleNewRateChange(e, 'silverRate')}
                                className="rate-input"
                            />
                            <GiSilverBullet className="input-icon silver-icon" />
                        </div>
                    </div>

                    <div className="input-group">
                        <label>Created By :</label>
                        <div className="input-with-icon">
                            <input
                                type="text"
                                value={newRate.createdBy}
                                onChange={(e) => handleNewRateChange(e, 'createdBy')}
                                className="rate-input"
                            />
                            <FaUser className="input-icon user-icon" />
                        </div>
                    </div>

                    <button
                        onClick={addNewRate}
                        className="add-rate-button"
                    >
                        Add Rate
                    </button>
                </div>
            </div>

            {/* Data Table */}
            <table className="rates-table">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Gold Rate</th>
                        <th>Silver Rate</th>
                        <th>Created At</th>
                        <th>Created By</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {Object.keys(rates).map((id) => {
                        const rate = rates[id];
                        return (
                            <tr key={id} className="table-row">
                                <td>{rate.id}</td>
                                <td>
                                    {editingId === id ? (
                                        <div className="input-with-icon">
                                            <input
                                                type="number"
                                                value={editableRate.goldRate}
                                                onChange={(e) => handleChange(e, 'goldRate')}
                                                className="table-input"
                                            />
                                            <GiGoldBar className="input-icon gold-icon" />
                                        </div>
                                    ) : rate.goldRate !== '0' ? (
                                        <div className="value-with-icon">
                                            {rate.goldRate}
                                            <GiGoldBar className="value-icon gold-icon" />
                                        </div>
                                    ) : (
                                        'N/A'
                                    )}
                                </td>
                                <td>
                                    {editingId === id ? (
                                        <div className="input-with-icon">
                                            <input
                                                type="number"
                                                value={editableRate.silverRate}
                                                onChange={(e) => handleChange(e, 'silverRate')}
                                                className="table-input"
                                            />
                                            <GiSilverBullet className="input-icon silver-icon" />
                                        </div>
                                    ) : rate.silverRate !== '0' ? (
                                        <div className="value-with-icon">
                                            {rate.silverRate}
                                            <GiSilverBullet className="value-icon silver-icon" />
                                        </div>
                                    ) : (
                                        'N/A'
                                    )}
                                </td>
                                <td>
                                    {editingId === id ? (
                                        <input
                                            type="date"
                                            value={editableRate.createdAt.split('T')[0]}
                                            onChange={(e) => handleChange(e, 'createdAt')}
                                            className="table-input"
                                        />
                                    ) : (
                                        rate.createdAt.split('T')[0]
                                    )}
                                </td>
                                <td>
                                    {editingId === id ? (
                                        <div className="input-with-icon">
                                            <input
                                                type="text"
                                                value={editableRate.createdBy}
                                                onChange={(e) => handleChange(e, 'createdBy')}
                                                className="table-input"
                                            />
                                            <FaUser className="input-icon user-icon" />
                                        </div>
                                    ) : (
                                        <div className="value-with-icon">
                                            {rate.createdBy}
                                            <FaUser className="value-icon user-icon" />
                                        </div>
                                    )}
                                </td>
                                <td>
                                    {editingId === id ? (
                                        <div className="action-buttons">
                                            <button
                                                onClick={saveEdit}
                                                className="save-button"
                                            >
                                                Save
                                            </button>
                                            <button
                                                onClick={cancelEdit}
                                                className="cancel-button"
                                            >
                                                Cancel
                                            </button>
                                        </div>
                                    ) : (
                                        <button
                                            onClick={() => startEditing(id)}
                                            className="edit-button"
                                        >
                                            Edit
                                        </button>
                                    )}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};

export default RateList;